module.exports = __webpack_public_path__ + "static/media/29EUNOG3.20c3a208.jpg";